import React, { useRef, useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";
import moment from "moment";
import convertToExcel from "../../../../components/ExportToExcel";
import Pagination from "../../../../components/Pagination";
import { useNavigate } from "react-router-dom";

const InputsDistributionFromMainWarehouseReport = () => {
  const frmRef = useRef({});
  const navigate = useNavigate();
 const redirectBasedOnUseCase = () => {
    const useCase = localStorage.getItem("useCase");

    switch (useCase) {
      case "Procurement":
        navigate("/fmnmis");
        break;

      case "Seed Production":
        navigate("/SeedMIS");
        break;

      case "Agri Promoter":
        navigate("/agrimis");
        break;

      case "Research Program":
        navigate("/researchProgramMIS");
        break;

      default:
        navigate("/fmnmis");
        break;
    }
  };

  const handleButtonClick = () => {
    redirectBasedOnUseCase();
  };
  const [employeeId, setEmployeeId] = useState(0);
  const [employeeData, setEmployeeData] = useState([]);

  const [warehouseId, setWarehouseId] = useState(0);
  const [warehouseData, setWarehouseData] = useState([]);

  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleFDateChange = (e) => {
    setSelectedFromDate(e.target.value);
    setData([]);
  };
  const handleTDateChange = (e) => {
    setSelectedToDate(e.target.value);
    setData([]);
  };

  const currentDate = new Date().toISOString().slice(0, 10);
  var d = new Date();
  d.setDate(d.getDate() - 15);

  const fromDate = d.toISOString().slice(0, 10);
  const [selectedFromDate, setSelectedFromDate] = useState(fromDate);

  const toDate = new Date().toISOString().slice(0, 10);

  const [selectedToDate, setSelectedToDate] = useState(toDate);

  const { sendRequest: getprocurementData } = useHttp();

  const fillData = (employeeId, warehouseId) => {
    var urlfilter = "";

    if (employeeId > 0) {
      urlfilter =urlfilter+ `&fieldExecutiveId=${employeeId}`;
    }

    if (warehouseId > 0) {
      urlfilter = urlfilter + `&warehouseId=${warehouseId}`;
    }

    urlfilter =
      urlfilter +
      `&fromDate=${moment(frmRef.current.Fdate.value).format("DD/MM/YYYY")}`;
    urlfilter =
      urlfilter +
      `&toDate=${moment(frmRef.current.Tdate.value).format("DD/MM/YYYY")}`;

    var url = `/api/distributionToMobileUserProductDetail/?orgId=${localStorage.getItem(
      "orgId"
    )}&&empId=${localStorage.getItem("empId")}${urlfilter} `;

    getprocurementData(
      {
        url: url,
      },
      (data) => {
        setData(data);
      }
    );
  };

  useEffect(() => {
    fillData(0, 0);
  }, [getprocurementData]);

  const { sendRequest: getEmp } = useHttp();

  const EmployeeDetail = () => {
    getEmp(
      {
        url: `/api/employeeListForProcReort/?useCase=Procurement&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")} `,
      },
      (data) => {
        //   console.log("emp", data);
        setEmployeeData(data);
      }
    );
  };

  useEffect(() => {
    EmployeeDetail(0);
  }, [getEmp]);

  const { sendRequest: getwarehouse } = useHttp();
  useEffect(() => {
    getwarehouse(
      {
        // url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}`,
        url: `/api/warehouses/?orgId=${localStorage.getItem("orgId")}&&storeTypeId=1&&createdBy=${localStorage.getItem("id")}`,
      },
      (data) => {
        setWarehouseData(data);
        console.log(data);
      }
    );
  }, [getwarehouse]);

  const fieldsToExport = [
    "goodsTransferDate",
    "goodsTrasnferNo",
    "productSubTypeName",
    "productName",
     "unitAbbreviation",
    "areaInHa",
    "pricePerUnit",
       "qtyPerHa",
                               
       "itemQuantity",
                              
      "productCost",

     "warehouseName",
    "issuedToEmployeeName",
    "createdDate",
  ];

  const customHeaders = [
    "Date",
    "Doc No",
    "Product Category",
    "Product",
    "UNIT",
    "Area",
    "Unit Cost",
    "Quantity/HA" ,
    "Quantity",
    "Total Cost",
    "PickUp Warehouse Name",
    "Destination Warehouse Name",
    "Created Date",
  ];

  const handleExportExcel = () => {
    const filename = "FieldOfficerGoodsTransfer(Productwise).xlsx";
    //console.log(fieldsToExport,customHeaders);
    const processedData = data.map((item) => ({
      ...item,
      farmerphoto: item.urlProfile ? `${process.env.REACT_APP_FILE_URL}${item.urlProfile}` : "",
      signature: item.signatureAttachment ? `${process.env.REACT_APP_FILE_URL}${item.signatureAttachment}` : "",
      createdDate: item.createdDate ? new Date(item.createdDate).toLocaleDateString("en-GB") : "",
    }));
    convertToExcel(processedData, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          {" "}
          <div className="col-md-8 mt-3">
            {" "}
            <label className="card-title mx-3">
              Field Officer Goods Transfer-Productwise
            </label>
          </div>
          <div className="col-md-4 text-right mt-3">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={handleButtonClick}
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <br />
        <section className="content">
          <div className="container-fluid">
            <hr />

            <div className="row">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Warehouse Name</label>
                  <select
                    id="warehouseId"
                    className="form-control"
                    ref={(el) => (frmRef.current["warehouseId"] = el)}
                    value={warehouseId}
                    onChange={(e) => {
                      setWarehouseId(e.target.value);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {warehouseData &&
                      warehouseData.map((x) => (
                        <option key={x.id} value={x.id}>
                          {x.name}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label htmlFor={"executive_officer"}>
                    {"Procurement Officer"}
                  </label>
                  <select
                    id="emp_id"
                    className="form-control"
                    ref={(el) => (frmRef.current["emp_id"] = el)}
                    value={employeeId}
                    onChange={(e) => {
                      setEmployeeId(e.target.value);
                      setData([]);
                    }}
                  >
                    <option value="">Select</option>
                    {employeeData &&
                      employeeData.map((x) => (
                        <option key={x.empId} value={x.empId}>
                          {x.employeeName}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  {" "}
                  <label htmlFor={"from_date"}>{"From Date"}</label>
                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["Fdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedFromDate}
                    onChange={handleFDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label htmlFor={"to_date"}>{"To Date"}</label>

                  <input
                    type={"date"}
                    id={"date"}
                    required
                    ref={(el) => (frmRef.current["Tdate"] = el)}
                    className="form-control"
                    max={currentDate}
                    value={selectedToDate}
                    onChange={handleTDateChange}
                  />
                </div>
              </div>
              <div className="col-md-2">
                <div className="form-group">
                  <label>&nbsp;</label>
                  <button
                    className="form-control btn btn-sm btn-primary"
                    onClick={(e) => {
                      fillData(employeeId, warehouseId);
                    }}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
          <h5>Please select the parameters to get the desired result</h5>
          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered text-center table-responsive">
                      <thead>
                        <tr className="table-header">
                         

                          <th> Date	</th>
                          <th>Doc No	</th>  
                          <th>Product Category	</th> 
                          <th>Product		</th> 
                          <th>UNIT	</th> 
                          <th>Area </th> 
                          <th>Unit Cost	</th> 
                          <th>Quantity/HA </th> 
                          <th>Quantity	</th> 
                          <th>Total Cost	</th> 
                          <th>PickUp Warehouse Name	</th> 
                          <th>Destination Warehouse Name</th> 
                          <th>Created Date</th> 

                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{itm.goodsTransferDate}</td>
                                <td>{itm.goodsTrasnferNo}</td>
                                 
                                <td>{itm.productSubTypeName}</td>
                                <td>{itm.productName}</td>
                                <td>{itm.unitAbbreviation}</td>
                                <td>{itm.areaInHa}</td>
                                <td>{itm.pricePerUnit}</td>
                                <td>{itm.qtyPerHa}</td>
                               
                                <td>{itm.itemQuantity}</td>
                              
                                <td>
                                  {parseFloat(itm.productCost).toFixed(2)}
                                </td>

                                <td>{itm.warehouseName}</td>
                                <td>{itm.issuedToEmployeeName}</td>
                                <td>{itm.createdDate}</td>
                                {/* <td>{new Date(itm.createdDate).toLocaleDateString()}</td> */}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default InputsDistributionFromMainWarehouseReport;
